var dl={};
(function(a){
    function b(){
        for (var a=0, b=arguments; a < b.length; a++){
            if (!b[a].event || (b[a].event && b[a].event.indexOf("gtm.")===-1)) {
                for (i in b[a]) {
                    dl[i]=b[a][i];
                }
            }
        }
    }
    var c=a.push;
    a.push=function(){
        b.apply(this,arguments);
        c.apply(a,arguments);
    };
    b.apply(a,a);
})
(window.dataLayer || []);

utag_data=dl;

(function(a,b,c,d){
    a='//tags.tiqcdn.com/utag/valassis/4235719-rentone/prod/utag.js';
    b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
})();
